import { render, staticRenderFns } from "./TaxonomyWide.vue?vue&type=template&id=50bfa06c&scoped=true"
import script from "./TaxonomyWide.vue?vue&type=script&lang=js"
export * from "./TaxonomyWide.vue?vue&type=script&lang=js"
import style0 from "./TaxonomyWide.vue?vue&type=style&index=0&id=50bfa06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bfa06c",
  null
  
)

export default component.exports